<template>
    <div class="union-download-landing" :class="[{'bg-white': styleType && styleType==1}]"
    v-if="layoutType && layoutType==2">
        <img class="cont-show" :src="contImgUrl" v-if="!isSlot">
        <div class="download-handle-wrap" v-if="!isSlot && isShowBtnCont">
            <div class="download-handle-item" @click="contHandle"><img :src="contBtnImgUrl"></div>
            <div class="download-handle-item" @click="contHandle_02"><img :src="contBtnImgUrl_02"></div>
        </div>
        <slot v-if="isSlot"></slot>
    </div>
    <div class="union-download-landing" :class="[{'bg-white': styleType && styleType==1}]" v-else>
        <img class="cont-show" :src="contImgUrl" v-if="!isSlot">
        <div class="cont-btn" v-if="!isSlot && isShowBtnCont">
            <img class="handle" :src="contBtnImgUrl" @click="contHandle">
        </div>
        <slot v-if="isSlot"></slot>
    </div>
</template>
<script>
export default {
    props: {
        contImgUrl: { //内容图片
            type: String,
            default: require("../../assets/images/download/download_landing_club_show.jpg")
        },
        contBtnImgUrl: { //内容按钮图片
            type: String,
            default: require("../../assets/images/download/download_landing_club_btn.png")
        },
        contLinkPath: { //内容跳转链接
            type: String
        },
        isCustomContHandle: { //是否自定义内容处理方法
            type: Boolean,
            default: false
        },

        contBtnImgUrl_02: { //内容按钮图片
            type: String,
            default: require("../../assets/images/download/download_landing_club_btn.png")
        },
        contLinkPath_02: { //内容跳转链接
            type: String
        },
        isCustomContHandle_02: { //是否自定义内容处理方法
            type: Boolean,
            default: false
        },

        isShowBtnCont: { //是否显示内容按钮
            type: Boolean,
            default: true
        },
        layoutType: { //布局类型: 1:1种平台通栏, 2:2种平台2栏
            type: Number,
            default: 1
        },
        styleType: { //风格: 0:默认, 1:白色背景
            type: Number,
            default: 0
        },
        btnCloseImgUrl: { //关闭按钮图片
            type: String,
            default: require("../../assets/images/download/download_guide_bar_btn_close.png")
        },
        isShowBtnClose: { //是否显示关闭按钮
            type: Boolean,
            default: false
        },
        isSlot: { //是否自定义插槽内容
            type: Boolean,
            default: false
        },
    },
    methods:{
        //关闭
        close(){
            this.$emit("close");
        },
        //内容事件
        contHandle(){
            if(this.isCustomContHandle){
                this.$emit("customHandle");
            } else {
                window.location.href = this.contLinkPath;
            }
        },
        //内容事件
        contHandle_02(){
            if(this.isCustomContHandle_02){
                this.$emit("customHandle_02");
            } else {
                window.location.href = this.contLinkPath_02;
            }
        },
    }
}
</script>
<style>
.union-download-landing{
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: #ebebea;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 10;
}
.union-download-landing.bg-white{
    background-color: #ffffff;
}
.union-download-landing .cont-show{
    width: 100%;
    display: block;
    margin: 0;
}
.union-download-landing .cont-btn{
    width: 100%;
    padding: 0.3rem 0 0.1rem;
    margin: 0;
    border-top: 1px solid #b5b6b6;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.union-download-landing .cont-btn .handle{
    width: 72%;
}
/* 2栏按钮 */
.union-download-landing .download-handle-wrap{
    width: 76.8%;
    margin: 0.3rem auto 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
}
.union-download-landing .download-handle-wrap .download-handle-item{
    flex: 1 1 auto;
}
.union-download-landing .download-handle-wrap .download-handle-item img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/shared/components/download/download-landing.vue